// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3li7O","gfeWrapper":"CalendarEvent_gfeWrapper__2h0Du"};